export default {
	sec_10: {
		title: {
			one: '지불 ',
			two: '방법',
		},
		desc: {
			one: '고객은 휴대폰 하나로 ',
			two: '가맹점에 지불 가능.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '가맹점에 지불된 자노페이는',
			},
			desc: {
				one: '가맹점별로 정산 또는 전체 가맹점 정산',
			},
		},
		two: {
			title: {
				one: '정산된 자노페이는 고정되어',
				two: '언제든지 출금 가능합니다.',
			},
		},
	},
};
